let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hzh3H")).then(() => parcelRequire('4y3Yq'));